// Local Functions
function getDisplayName(prefix, WrappedComponent) {
  const componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  return `${prefix}(${componentName})`;
}

// Module Exports
export { getDisplayName };
